import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css'
import JUDE from 'styles/img/jude.png'
import MICHAEL from 'styles/img/michael.png'
export default class CarouselWrapper extends React.Component{


  render(){
    // let michael = {
    //   background: 'url("/styles/img/michael.png") 50% 50% no-repeat',
    //   backgroundSize: 'cover',
    //   width: '100%',
    //   height: '100%'
    // };
    let jude = {
      background: 'url("' + JUDE + '") 50% 50% no-repeat',
      backgroundSize: 'cover',
      width: '100%',
      height: '100%'
    };
    let text = 'This course is ideal for those who\n' +
      '              are starting out and have little business experience.\n' +
      '              It will introduce you to the idea of your practice\n' +
      '              as a business, and guide you through the steps you will need to take.';
    let mainObject = {
      name: 'Jude Fay',
      text: text,
      type: 'Workshop Provider',
      newType: 'This Business of Therapy'
    };

    if(this.props.isMichael) {
      jude = {
        background: 'url("' + MICHAEL + '") 50% 50% no-repeat',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      };
      mainObject = {
        name: 'Michael O\' Carroll',
        text: 'CPD is very important for all practitioners.' +
        ' Building up your CPD hours doesn\'t have to be a chore -' +
        ' it can be easy, fun and convenient. From the comfort of your' +
        ' own home, Therapy Academy enables you to learn and' +
        ' maintain your professional standards.',
        type: 'Therapy Academy Founder',
        newType: 'Workshops Provider'
      }
    }
    return(
      <Carousel showStatus={false}
                showThumbs={false}
                showArrows={false}
                className="carousel-wrapper">

        <div style={jude}>
          <div className="new-user-background-image"/>
          <div className="legend">
            <p className="legend-title">{mainObject.text}
            </p>
            <div className="legend-author">
              <p className="legend-author-name">- {mainObject.name}</p>
              <p className="legend-author-position">{mainObject.type}</p>

              <p className="legend-author-position">{mainObject.newType}</p>
            </div>
          </div>
        </div>
      </Carousel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/new_user/CarouselWrapper.jsx